<template>
    <div
        id="editor"
        class="col-sm-12 nopads"
    >
        <div class="col-sm-12 editor-form p-1">
            <div class="col-sm-12 form-data">
                <h4 class="form-header">
                    {{ $t('contracts.basic_info') }}
                </h4>
                <div class="row">
                    <div class="col-md-6">
                        <span class="span-title">
                            {{ $t('vehicle_editor.registration_number') }}
                        </span>
                        <input
                            id="license_plate"
                            v-model="vehicleUpdate.license_plate"
                            type="text"
                            class="form-control form-control-sm"
                        >
                    </div>
                    <div class="col-md-6">
                        <span class="span-title">
                            {{ $t('vehicle_editor.type') }}
                        </span>
                        <select
                            id="vehicle_type"
                            v-model="vehicleUpdate.vehicle_type"
                            class="form-select form-select-sm"
                        >
                            <option
                                v-for="item in sortedVehicleTypes"
                                :key="item.value"
                                :value="item.value"
                            >
                                {{ item.text }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <span class="span-title">
                            {{ $t('vehicle_editor.make') }}
                        </span>
                        <input
                            id="make"
                            v-model="vehicleUpdate.make"
                            type="text"
                            class="form-control form-control-sm"
                        >
                    </div>
                    <div class="col-md-6">
                        <span class="span-title">
                            {{ $t('vehicle_editor.model') }}
                        </span>
                        <input
                            id="vehicle_model"
                            v-model="vehicleUpdate.vehicle_model"
                            type="text"
                            class="form-control form-control-sm"
                        >
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <span class="span-title">
                            {{ $t('vehicle_editor.in_use') }}
                        </span>
                        <div class="form-check form-switch">
                            <input
                                id="in_use"
                                v-model="vehicleUpdate.in_use"
                                class="form-check-input"
                                type="checkbox"
                            >
                        </div>
                    </div>
                    <!--
             <div class="col-md-6">
            <span class="span-title">
              {{ $t('vehicle_editor.depot_id') }}
            </span>
              <input
                  id="depot_id"
                  v-model="vehicleUpdate.depot_id"
                  type="text"
                  class="form-control form-control-sm"
              />
          </div>
-->
                </div>
                <div class="row">
                    <div class="col-md-12">
                        {{ vehicleUpdate.home_location }}
                        <coordinate-editor
                            v-model="vehicleUpdate.home_location"
                            :title="$t('vehicle_editor.home_location')"
                            :point-type="1"
                            :show-buttons="false"
                            :user="user"
                        />
                    </div>
                </div>
                <hr>
                <h4 class="form-header">
                    {{ $t('vehicle_editor.work_accessory_info') }}
                </h4>
                <div class="row">
                    <div class="col-md-6">
                        <span class="span-title">
                            {{ $t('vehicle_editor.plow_width') }}
                        </span>
                        <input
                            id="plow_width"
                            v-model="vehicleUpdate.plow_width"
                            type="number"
                            min="0"
                            max="20"
                            step="any"
                            class="form-control form-control-sm"
                        >
                    </div>
                    <div class="col-md-6">
                        <span class="span-title">
                            {{ $t('vehicle_editor.spread_width') }}
                        </span>
                        <input
                            id="spread_width"
                            v-model="vehicleUpdate.spread_width"
                            type="number"
                            min="0"
                            max="20"
                            step="any"
                            class="form-control form-control-sm"
                        >
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <span class="span-title">
                            {{ $t('vehicle_editor.working_width') }}
                        </span>
                        <input
                            id="working_width"
                            v-model="vehicleUpdate.working_width"
                            type="number"
                            min="1000"
                            max="20000"
                            step="any"
                            class="form-control form-control-sm"
                        >
                    </div>
                    <div class="col-md-6">
                        <span class="span-title">
                            {{ $t('vehicle_editor.max_speed') }}
                        </span>
                        <input
                            id="max_speed"
                            v-model="vehicleUpdate.max_speed"
                            type="number"
                            min="1"
                            max="300"
                            step="any"
                            class="form-control form-control-sm"
                        >
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <span class="span-title">
                            {{ $t('vehicle_editor.working_speed') }}
                        </span>
                        <input
                            id="working_speed"
                            v-model="vehicleUpdate.working_speed"
                            type="number"
                            min="1"
                            max="100"
                            step="any"
                            class="form-control form-control-sm"
                        >
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <span class="span-title">
                            {{ $t('vehicle_editor.spreader_id') }}
                        </span>
                        <input
                            id="spreader_id"
                            v-model="vehicleUpdate.spreader_id"
                            type="text"
                            class="form-control form-control-sm"
                        >
                    </div>
                    <div class="col-md-6">
                        <span class="span-title">
                            {{ $t('vehicle_editor.spreader_manufacturer') }}
                        </span>
                        <select
                            id="fuel_type"
                            v-model="vehicleUpdate.spreader_manufacturer"
                            class="form-select form-select-sm"
                        >
                            <option
                                v-for="option in spreaderManufacturers"
                                :key="option.value"
                                :value="option.value"
                            >
                                {{ option.text }}
                            </option>
                        </select>
                    </div>
                </div>
                <hr>
                <h4 class="form-header">
                    {{ $t('vehicle_editor.additional_info') }}
                </h4>
                <div class="row">
                    <div class="col-md-6">
                        <span class="span-title">
                            {{ $t('vehicle_editor.co2_emissions') }}
                        </span>
                        <input
                            id="co2_emission"
                            v-model="vehicleUpdate.co2_emission"
                            type="number"
                            min="0"
                            step="any"
                            class="form-control form-control-sm"
                        >
                    </div>
                    <div class="col-md-6">
                        <span class="span-title">
                            {{ $t('vehicle_editor.vin') }}
                        </span>
                        <input
                            id="vin"
                            v-model="vehicleUpdate.vin"
                            type="text"
                            class="form-control form-control-sm"
                        >
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <span class="span-title">
                            {{ $t('vehicle_editor.fuel_type') }}
                        </span>
                        <select
                            id="fuel_type"
                            v-model="vehicleUpdate.fuel_type"
                            class="form-select form-select-sm"
                        >
                            <option
                                v-for="fuelType in fuelTypes"
                                :key="fuelType.value"
                                :value="fuelType.value"
                            >
                                {{ fuelType.text }}
                            </option>
                        </select>
                    </div>
                    <div class="col-md-6">
                        <span class="span-title">
                            {{ $t('vehicle_editor.fuel_consumption') }}
                        </span>
                        <input
                            id="fuel_consumption"
                            v-model="vehicleUpdate.fuel_consumption"
                            type="number"
                            min="0"
                            step="any"
                            class="form-control form-control-sm"
                        >
                    </div>
                    <div class="col-md-6">
                        <span class="span-title">
                            {{ $t('vehicle_editor.fuel_consumption_per_hour') }}
                        </span>
                        <input
                            id="fuel_consumption_per_hour"
                            v-model="vehicleUpdate.fuel_consumption_per_hour"
                            type="number"
                            min="0"
                            step="any"
                            class="form-control form-control-sm"
                        >
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <span class="span-title">
                            {{ $t('vehicle_editor.emission_standard') }}
                        </span>
                        <select
                            id="emission_standard"
                            v-model="vehicleUpdate.emission_standard"
                            class="form-select form-select-sm"
                        >
                            <option
                                v-for="option in emissionStandardTypes"
                                :key="option.value"
                                :value="option.value"
                            >
                                {{ option.text }}
                            </option>
                        </select>
                    </div>
                    <div class="col-md-6">
                        <span class="span-title">
                            {{ $t('vehicle_editor.model_year') }}
                        </span>
                        <input
                            id="model_year"
                            v-model="vehicleUpdate.model_year"
                            type="number"
                            min="0"
                            class="form-control form-control-sm"
                        >
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <span class="span-title">
                            {{ $t('vehicle_editor.emission_standard_other') }}
                        </span>
                        <textarea
                            id="emission_standard_extra_info"
                            v-model="vehicleUpdate.emission_standard_extra_info"
                            rows="3"
                            class="form-control form-control-sm"
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <span class="span-title">
                            {{ $t('vehicle_editor.engine_capacity') }}
                        </span>
                        <input
                            id="displacement"
                            v-model="vehicleUpdate.displacement"
                            type="number"
                            class="form-control form-control-sm"
                            :min="0"
                            step="any"
                            @change="vehicleUpdate.displacement = vehicleUpdate.displacement >= 0 ? vehicleUpdate.displacement : null"
                        >
                    </div>
                    <div class="col-md-6">
                        <span class="span-title">
                            {{ $t('vehicle_editor.weight') }}
                        </span>
                        <input
                            id="weight"
                            v-model="vehicleUpdate.weight"
                            type="number"
                            class="form-control form-control-sm"
                            :min="0"
                            step="any"
                            @change="vehicleUpdate.weight = vehicleUpdate.weight >= 0 ? vehicleUpdate.weight : null"
                        >
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <span class="span-title">
                            {{ $t('vehicle_editor.last_inspection') }}
                        </span>
                        <input
                            id="last_inspection"
                            type="date"
                            :value="timestampToDateInput(vehicleUpdate.last_inspection)"
                            class="form-control form-control-sm"
                            @blur="updateLastInspection"
                        >
                    </div>
                    <div class="col-md-6">
                        <span class="span-title">
                            {{ $t('vehicle_editor.next_inspection') }}
                        </span>
                        <input
                            id="next_inspection"
                            type="date"
                            :value="timestampToDateInput(vehicleUpdate.next_inspection)"
                            class="form-control form-control-sm"
                            @blur="updateNextInspection"
                        >
                    </div>
                </div>

                <div class="row">
                    <!-- Photo editor-->
                    <div class="col-12">
                        <!-- Show selected photos -->
                        <div
                            v-for="(file, index) in photos"
                            :key="index"
                            class="d-flex align-items-center justify-content-between mb-3"
                        >
                            <span>{{ file?.name || file }}</span>
                            <button
                                class="btn btn-outline-danger btn-sm"
                                type="button"
                                @click="removePhoto(index)"
                            >
                                {{ $t('common.remove') }}
                            </button>
                        </div>

                        <!-- Hidden file input -->
                        <input
                            ref="photoInput"
                            type="file"
                            accept="image/jpeg,image/jpg,image/png"
                            class="visually-hidden"
                            @change="handlePhotoChange"
                        >
                    </div>
                </div>
                <div class="col-sm-12 nopads mt-3 d-flex justify-content-end">
                    <button
                        class="btn btn-outline-primary form-button"
                        type="button"
                        @click="triggerPhotoInput"
                    >
                        {{ $t('power_stations.add_photo') }}
                    </button>

                    <button
                        class="btn btn-secondary form-button"
                        @click.stop="$emit('close')"
                    >
                        {{ $t('common.close') }}
                    </button>
                    <button
                        class="btn btn-success form-button"
                        :disabled="loading || !isValidVehicle"
                        @click.stop="submitVehicle"
                    >
                        {{ $t('common.save') }}
                    </button>
                </div>
            </div>
        </div>
        <div
            v-if="loading"
            id="loader"
            class="spinner"
        />
    </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {emissionStandard, vehicleFuel, vehicleHelper} from '../mixins/VehicleMixin'
import {timeUtils} from '../mixins/TimeUtils'
import {mapHelper} from "@/components/mixins/MapMixin";
import {attachmentHelper} from "@/components/mixins/AttachmentMixin";
import {inject} from "vue";
import CoordinateEditor from '../CoordinateEditor.vue'

export default {
    name: 'VehicleEditor',
    components: {
        CoordinateEditor
    },
    mixins: [vehicleHelper, restApi, timeUtils, mapHelper, attachmentHelper],
    props: {
        vehicle: {
            type: Object,
            default: null
        },
        closeWhenUpdate: {
            type: Boolean,
            default: false
        },
        user: {
            type: Object,
            default: null
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert')
        return { showAlert }
    },
    data: function () {
        return {
            loading: false,
            vehicleLocation: null,
            lastLocationTime: '',
            photos: [],
            vehicleUpdate: this.jsonToVehicle(this.vehicle)
        }
    },
    computed: {
        isValidVehicle() {
            const v = this.vehicleUpdate
            if (v.max_speed && (v.max_speed < 1 || v.max_speed > 300)) return false
            if (v.working_speed && (v.working_speed < 1 || v.working_speed > 100)) return false
            if (v.working_width && (v.working_width < 1000 || v.working_width > 20000)) return false
            return true
        },

        vehicleTypes() {
            return [
                {value: 1, text: this.$t('vehicle_list.vehicle_type.passenger_or_van')},
                {value: 2, text: this.$t('vehicle_list.vehicle_type.truck')},
                {value: 3, text: this.$t('vehicle_list.vehicle_type.trailer')},
                {value: 4, text: this.$t('vehicle_list.vehicle_type.trailer1')},
                {value: 5, text: this.$t('vehicle_list.vehicle_type.loader')},
                {value: 6, text: this.$t('vehicle_list.vehicle_type.tractor')},
                {value: 11, text: this.$t('vehicle_list.vehicle_type.snowplow')},
                {value: 7, text: this.$t('vehicle_list.vehicle_type.spreader')},
                {value: 8, text: this.$t('vehicle_list.vehicle_type.harvester')},
                {value: 9, text: this.$t('vehicle_list.vehicle_type.forwarder')},
                {value: 12, text: this.$t('vehicle_list.vehicle_type.helicopter')},
                {value: 13, text: this.$t('vehicle_list.vehicle_type.paver')},
                {value: 14, text: this.$t('vehicle_list.vehicle_type.road_fence')},
                {value: 15, text: this.$t('vehicle_list.vehicle_type.shock_absorber')},
                {value: 16, text: this.$t('vehicle_list.vehicle_type.digger')},
                {value: 10, text: this.$t('vehicle_list.vehicle_type.other')}
            ]
        },

        sortedVehicleTypes() {
            const vehicles = this.vehicleTypes
            return vehicles.sort((a, b) => {
                if (a.value === 10) {
                    return 1
                }
                return a.text.localeCompare(b.text, this.$i18n.locale)
            })
        },


        fuelTypes() {
            return [
                {value: vehicleFuel.UNKNOWN, text: this.getFuelTypeName(vehicleFuel.UNKNOWN)},
                {value: vehicleFuel.FUEL_98E, text: this.getFuelTypeName(vehicleFuel.FUEL_98E)},
                {value: vehicleFuel.FUEL_95E10, text: this.getFuelTypeName(vehicleFuel.FUEL_95E10)},
                {value: vehicleFuel.DIESEL, text: this.getFuelTypeName(vehicleFuel.DIESEL)},
                {value: vehicleFuel.HVO, text: this.getFuelTypeName(vehicleFuel.HVO)},
                {value: vehicleFuel.FUEL_OIL, text: this.getFuelTypeName(vehicleFuel.FUEL_OIL)},
                {value: vehicleFuel.GAS_CNG, text: this.getFuelTypeName(vehicleFuel.GAS_CNG)},
                {value: vehicleFuel.GAS_CBG, text: this.getFuelTypeName(vehicleFuel.GAS_CBG)},
                {value: vehicleFuel.GAS_LNG, text: this.getFuelTypeName(vehicleFuel.GAS_LNG)},
                {value: vehicleFuel.HYBRID, text: this.getFuelTypeName(vehicleFuel.HYBRID)},
                {value: vehicleFuel.ELECTRIC, text: this.getFuelTypeName(vehicleFuel.ELECTRIC)},
                {value: vehicleFuel.OTHER, text: this.getFuelTypeName(vehicleFuel.OTHER)}
            ]
        },
        emissionStandardTypes() {
            return [
                {value: emissionStandard.EURO1, text: this.getEmissionStandardName(emissionStandard.EURO1)},
                {value: emissionStandard.EURO2, text: this.getEmissionStandardName(emissionStandard.EURO2)},
                {value: emissionStandard.EURO3, text: this.getEmissionStandardName(emissionStandard.EURO3)},
                {value: emissionStandard.EURO4, text: this.getEmissionStandardName(emissionStandard.EURO4)},
                {value: emissionStandard.EURO5, text: this.getEmissionStandardName(emissionStandard.EURO5)},
                {value: emissionStandard.EURO6, text: this.getEmissionStandardName(emissionStandard.EURO6)},
                {value: emissionStandard.STAGEV, text: this.getEmissionStandardName(emissionStandard.STAGEV)},
                {value: emissionStandard.STAGEIV, text: this.getEmissionStandardName(emissionStandard.STAGEIV)},
                {value: emissionStandard.STAGEIIIB, text: this.getEmissionStandardName(emissionStandard.STAGEIIIB)},
                {value: emissionStandard.STAGEIIIA, text: this.getEmissionStandardName(emissionStandard.STAGEIIIA)},
                {value: emissionStandard.STAGEII, text: this.getEmissionStandardName(emissionStandard.STAGEII)},
                {value: emissionStandard.STAGEI, text: this.getEmissionStandardName(emissionStandard.STAGEI)},
                {value: emissionStandard.UNKNOWN, text: this.getEmissionStandardName(emissionStandard.UNKNOWN)},
                {value: emissionStandard.OTHER, text: this.getEmissionStandardName(emissionStandard.OTHER)}
            ]
        },
        spreaderManufacturers() {
            return [
                {value: null, text: this.$t('common.unknown')},
                {value: 1, text: 'Arctic Machine'},
                {value: 2, text: 'Rasko'},
                {value: 3, text: 'Fleetlogis'},
            ]
        },
    },
    methods: {
        triggerPhotoInput() {
            this.$refs.photoInput?.click();
        },
        handlePhotoChange(event) {
            const file = event.target.files[0];
            if (file) {
                this.photos.push(file);
            }
            // Clear input value so the same file can be selected again if needed
            event.target.value = '';
        },
        removePhoto(index) {
            this.photos.splice(index, 1);
        },

        updateLastInspection: function (event) {
            if (event.target.value) {
                this.vehicleUpdate.last_inspection = new Date(event.target.value)
            } else {
                this.vehicleUpdate.last_inspection = undefined
            }
        },
        updateNextInspection: function (event) {
            if (event.target.value) {
                this.vehicleUpdate.next_inspection = new Date(event.target.value)
            } else {
                this.vehicleUpdate.next_inspection = undefined
            }
        },
        validateVehicleAttributes: function (vehicle) {
            if (vehicle.max_speed && (vehicle.max_speed < 1 || vehicle.max_speed > 300)) {
                this.showAlert(this.$t('vehicle_editor.validation.max_speed_range'))
                return false
            }
            if (vehicle.working_speed && (vehicle.working_speed < 1 || vehicle.working_speed > 100)) {
                this.showAlert(this.$t('vehicle_editor.validation.working_speed_range'))
                return false
            }
            if (vehicle.working_width && (vehicle.working_width < 1000 || vehicle.working_width > 20000)) {
                this.showAlert(this.$t('vehicle_editor.validation.working_width_range'))
                return false
            }
            return true
        },

        setDefaultValues: function (vehicle) {
            if (!vehicle.license_plate) {
                this.showAlert(this.$t('vehicle_editor.missing_license_plate'))
                return undefined
            }
            if (!vehicle.vehicle_type) {
                this.showAlert(this.$t('vehicle_editor.missing_type'))
                return undefined
            }
            if (!this.validateVehicleAttributes(vehicle)) {
                return undefined
            }
            if (!vehicle.displacement) {
                vehicle.displacement = 0
            }
            if (vehicle.last_inspection && (vehicle.last_inspection instanceof Date)) {
                if (!isNaN(vehicle.last_inspection.getTime())) {
                    vehicle.last_inspection = vehicle.last_inspection.toISOString()
                } else {
                    vehicle.last_inspection = undefined
                }
            }
            if (vehicle.next_inspection && (vehicle.next_inspection instanceof Date)) {
                if (!isNaN(vehicle.next_inspection.getTime())) {
                    vehicle.next_inspection = vehicle.next_inspection.toISOString()
                } else {
                    vehicle.next_inspection = undefined
                }
            }
            if (!vehicle.plow_width) {
                vehicle.plow_width = 0
            } else {
                vehicle.plow_width = parseFloat(vehicle.plow_width)
            }
            if (!vehicle.spread_width) {
                vehicle.spread_width = 0
            } else {
                vehicle.spread_width = parseFloat(vehicle.spread_width)
            }

            vehicle.working_width = vehicle.working_width !== '' && vehicle.working_width != null ? parseInt(vehicle.working_width) : null
            vehicle.max_speed = vehicle.max_speed !== '' && vehicle.max_speed != null ? parseInt(vehicle.max_speed) : null
            vehicle.working_speed = vehicle.working_speed !== '' && vehicle.working_speed != null ? parseInt(vehicle.working_speed) : null

            if (!vehicle.fuel_consumption_per_hour) {
                vehicle.fuel_consumption_per_hour = 0
            } else {
                vehicle.fuel_consumption_per_hour = parseFloat(vehicle.fuel_consumption_per_hour)
            }

            return vehicle
        },

        submitVehicle: function () {
            if (!this.validateVehicleAttributes(this.vehicleUpdate)) {
                return
            }
            var jsonVehicle = this.setDefaultValues(this.vehicleUpdate)
            if (jsonVehicle) {
                this.loading = true
                if (this.vehicle.id < 1) {
                    this.restAdd(this.vehicleUrl, jsonVehicle, this.success, this.fail)
                } else {
                    this.restUpdate(this.vehicleUrl, jsonVehicle, this.success, this.fail)
                }
            }
        },

        success: function (response) {
            let photos = this.getValidAttachments(this.photos)
            if (photos.length > 0) {
                this.uploadPhoto(photos, response.id)
            } else {
                this.uploadCompleted()
            }
        },

        uploadCompleted: function () {
            if (this.vehicle.id < 1 || this.closeWhenUpdate) {
                this.$emit('added')
            }
            this.loading = false
            this.showAlert(this.$t('common.alert_add_success'), 'success')
        },

        fail: function () {
            this.showAlert(this.$t('common.alert_update_failed'))
            this.loading = false
        },

        uploadPhoto: function (photos, id) {
            if (photos.length > 0) {
                this.loading = true
                let formData = new FormData()
                photos.forEach(photoFile => {
                    if (photoFile !== undefined && photoFile !== null) {
                        formData.append('photos[]', photoFile)
                    }
                })
                let url = this.vehicleUrl + "/" + id + "/photo"
                this.restPostWithFile(url, {}, formData, this.photoSuccess, this.fail)
            }
        },

        photoSuccess: function () {
            this.loading = false
            if (this.vehicle.id < 1 || this.closeWhenUpdate) {
                this.$emit('added')
            }
            this.showAlert(this.$t('common.alert_add_success'), 'success')
        }
    }
}
</script>
